// Mock data for Motherstore

export const heroData = {
  title: "Motherstore",
  subtitle: "L'élégance parisienne au cœur de votre quotidien",
  description: "Découvrez notre collection de vêtements féminins raffinés, sélectionnés avec soin dans notre boutique près de la Place de la Concorde",
  image: "https://images.unsplash.com/photo-1591289247430-b2701344abe0"
};

export const boutiqueData = {
  title: "Notre Boutique",
  subtitle: "Une expérience unique au cœur de Paris",
  description: "Située dans le quartier historique près de la Place de la Concorde, Motherstore est bien plus qu'une boutique de vêtements. C'est un havre de douceur et d'élégance où chaque femme trouve son style unique. Notre espace chaleureux et féminin vous accueille pour une expérience shopping personnalisée, dans l'ambiance intimiste d'une boutique de quartier parisienne.",
  features: [
    {
      title: "Ambiance Chaleureuse",
      description: "Un espace cosy et accueillant qui vous fait sentir comme à la maison"
    },
    {
      title: "Conseil Personnalisé",
      description: "Notre équipe vous accompagne pour trouver les pièces qui vous subliment"
    },
    {
      title: "Sélection Raffinée",
      description: "Des collections soigneusement choisies pour leur qualité et leur élégance"
    }
  ],
  images: [
    "https://images.unsplash.com/photo-1679393320543-dbfe384e4710?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxib3V0aXF1ZSUyMGludGVyaW9yfGVufDB8fHx8MTc3NTg0MjEzMHww&ixlib=rb-4.1.0&q=85",
    "https://images.pexels.com/photos/35844838/pexels-photo-35844838.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  ]
};

export const collectionsData = [
  {
    id: 1,
    name: "Collection Casual",
    description: "L'élégance décontractée pour votre quotidien parisien",
    image: "https://images.unsplash.com/photo-1766937537767-73343532f10b",
    items: ["Pulls doux", "Pantalons confortables", "Chemises fluides"]
  },
  {
    id: 2,
    name: "Collection Élégant",
    description: "Sophistication et raffinement pour toutes les occasions",
    image: "https://images.unsplash.com/photo-1637690048998-1e41c61c254d",
    items: ["Robes sophistiquées", "Tailleurs chic", "Accessoires raffinés"]
  },
  {
    id: 3,
    name: "Collection Soirée",
    description: "Brillez lors de vos événements les plus précieux",
    image: "https://images.unsplash.com/photo-1646526822625-5376570a4832",
    items: ["Robes de cocktail", "Tenues de gala", "Bijoux élégants"]
  }
];

export const contactData = {
  address: {
    name: "Motherstore",
    street: "15 Rue Saint-Honoré",
    city: "75001 Paris",
    country: "France",
    phone: "+33 1 42 60 12 34",
    email: "contact@motherstore.fr"
  },
  hours: {
    weekdays: "Lundi - Samedi: 10h00 - 19h00",
    sunday: "Dimanche: Fermé"
  },
  social: {
    instagram: "https://instagram.com/motherstore.paris",
    facebook: "https://facebook.com/motherstore.paris"
  }
};
